import { useClientSearchParams } from "@/shared/hooks/useClientSearchParams";
import Flex from "../../common/Flex";
import type { FilterComponent } from "../filter.types";
import { Input } from "../../common/Input";

const QueryFilter: FilterComponent<string> = ({ applyFilter, placeholder }) => {
  const currentState = useClientSearchParams().get("query") ?? "";

  return (
    <Flex
      alignItems={"center"}
      justifyContent={"center"}
      className="md:pb-4 w-full"
    >
      <Input
        placeholder={placeholder}
        onChange={(event) => applyFilter(event.target.value)()}
        type="text"
        className="h-11 rounded-full place bg-background border-border shadow-none w-full"
        defaultValue={currentState}
      />
    </Flex>
  );
};

export default QueryFilter;
